import { Component, Input, OnInit } from '@angular/core';
import { DatabaseService } from "../providers/database.service";
declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-mediator',
  templateUrl: './mediator.component.html',
  styleUrls: ['./mediator.component.css']
})
export class MediatorComponent implements OnInit {
  @Input() mediator: string = "not yet";
  mediatorList: any[] = [];
  selMediator = { name: 'not yet' };
  confDone = false;

  constructor(public db: DatabaseService) {
    var ref = db.getMediators();
    ref.on('value',
      snap => {
        var medsObject = snap.val();
        this.mediatorList = Object.keys(medsObject).map(
          key => {
            return medsObject[key];
          }
        )
      });
    // console.log("MediatorComponent", this.mediator, this.mediatorList);
  }

  getMediators() {
    // console.log("getMediators()", this.mediator, this.mediatorList);
    var shortList: any[] = [];
    for (let med of this.mediatorList) {
      // console.log('comparing: ' + med.type + " - " + this.mediator);
      if (med.type === this.mediator) {
        shortList.push(med);
      }
    }
    return shortList;
  }

  select(obj: any) {
    this.selMediator = obj;
    this.confDone = true;
  }

  ngOnInit() {
    // console.log("ngOnInit()", this.mediator, this.mediatorList);  
  }

  done() {
    document.getElementById('list-conf-list').classList.add('disabled');
    document.getElementById('list-out-list').classList.remove('disabled');
    document.getElementById('list-out-list').click();
  }
}

@Component({
  selector: 'addnew-mediator',
  templateUrl: './addnew.mediator.html',
  styleUrls: ['./mediator.component.css']
})
export class AddNewMediator extends MediatorComponent {

  name: string;
  url: string;
  type: string = "please select";
  streamUrl: string;
  schemaFile: File = null;

  setType(t: string) {
    this.type = t;
  }

  setFile(event: any) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      this.schemaFile = fileList[0];
      console.log('set upload file: ' + this.schemaFile.name + ' - ' + this.schemaFile.size + ' bytes');
    }
  }

  onSubmit() {
    var field = document.getElementById('schemaField');
    console.log("onSubmit: " + this.name + ", " + this.url + ", " + this.type + ", " + this.schemaFile.name);
    var mInfo = {
      name: this.name,
      url: this.url,
      type: this.type,
      schemaFile: this.schemaFile
    }
    this.db.addMediator(mInfo);

    document.getElementById('list-sel-list').classList.remove('disabled');
    document.getElementById('list-conf-list').classList.add('disabled');
    document.getElementById('list-out-list').classList.add('disabled');
    document.getElementById('list-sel-list').click();

  }
}





// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/mediator/mediator.component.ts